// Guest API client configuration with credentials support for guest sessions
import axios from 'axios';

const guestApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  withCredentials: true, // Enable cookies for guest refresh tokens
  headers: {
    'Content-Type': 'application/json'
  }
});

export default guestApi;
